'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _search = require('./view/search.js');

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _search2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-search/lib/index.js
// module id = 218
// module chunks = 0